<script lang="ts" setup>
defineProps({
	line: {
		type: Number,
		default: 10,
	},
})

function getRandomWidth() {
	const startValue = 30
	const endValue = 90
	return Math.floor(Math.random() * (endValue - startValue + 1)) + startValue
}
</script>

<template>
	<div class="bs-how-it-works-skeleton">
		<div
			v-for="index in line"
			:key="index"
			class="bs-how-it-works-skeleton__animation"
			:style="`width: ${getRandomWidth()}%;`"
		></div>
	</div>
</template>
